// Central legal-entity + policy constants for Balagha.
// Referenced by Privacy, Terms, IP Notice, Contact, Pricing, and Profile pages.
// If any of these change, update HERE — not scattered throughout the app.

export const LEGAL = {
  // Registered legal entity (per Saudi Commercial Registration)
  entity_ar: "مؤسّسة تقنيات بلاغة",
  entity_en: "Taqniyat Balaghah Establishment",
  cr_number: "7054773218",
  jurisdiction_ar: "المملكة العربيّة السعوديّة",
  city_ar: "مكّة المكرّمة",
  city_en: "Makkah",
  country_ar: "المملكة العربيّة السعوديّة",
  country_en: "Kingdom of Saudi Arabia",
  address_ar: "مكّة المكرّمة، المملكة العربيّة السعوديّة",
  address_en: "Makkah, Kingdom of Saudi Arabia",

  // Contact
  email: "info@balagha.tech",
  privacy_email: "info@balagha.tech",
  support_email: "info@balagha.tech",

  // App identity
  app_name_ar: "بَلاغة",
  app_name_en: "Balagha",
  bundle_id: "com.balagha.app",
  website: "https://www.balagha.tech",
  age_rating: "12+",

  // Content policy dates (Hijri-agnostic; ISO)
  last_updated: "24 يوليو 2026",

  // Data retention (used by Privacy)
  retention_active_days: 730,   // 24 months while account is active
  retention_deletion_days: 30,  // 30 days grace after account deletion request

  // Subscription (auto-renewing)
  trial_enabled: false,
};

export const LEGAL_LINKS = {
  privacy: "/privacy",
  terms: "/terms",
  ip: "/ip-notice",
  contact: "/contact",
  // Standard Apple EULA reference (Apple's default is used unless overridden)
  apple_eula: "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/",
};
